import { BaseService } from '@services/BaseService';
import { ProfileViewModel } from '@models/Auth';
import { PageViewModel } from '@models/common.models';

class UsersService extends BaseService {
  constructor() {
    super('auth/users');
  }

  public create(model: ProfileViewModel): Promise<number> {
    return this.fetch<number>('', {
      method: 'POST',
      body: JSON.stringify(model)
    });
  }

  public get(id: number): Promise<ProfileViewModel> {
    return this.fetch<ProfileViewModel>(id.toString(), {
      method: 'GET'
    });
  }

  public getCurrentUser(): Promise<ProfileViewModel> {
    return this.fetch<ProfileViewModel>('current', {
      method: 'GET'
    });
  }

  public search(pageNumber: number, pageSize: number, query: string | null): Promise<PageViewModel<ProfileViewModel>> {
    const pn: number = Math.max(1, pageNumber);
    const ps: number = Math.max(0, pageSize);

    let relativeUri = `?pageNumber=${pn}&pageSize=${ps}`;
    if (query && query !== '') {
      relativeUri += `&query=${query}`;
    }

    return this.fetch<PageViewModel<ProfileViewModel>>(relativeUri, {
      method: 'GET'
    });
  }

  public update(model: ProfileViewModel): Promise<ProfileViewModel> {
    return this.fetch(model.id.toString(), {
      method: 'PUT',
      body: JSON.stringify(model)
    });
  }

  public getEmployee(employeeId: number): Promise<ProfileViewModel> {
    const uri: string = `employee/${employeeId}`;
    return this.fetch<ProfileViewModel>(uri, {
      method: 'GET'
    });
  }
}

export const usersService = new UsersService();



// WEBPACK FOOTER //
// ./src/_services/UsersService.ts